import Vue from 'vue';
import { NoteState } from './state';
import { MutationTree } from 'vuex';
import { NoteModel, GroupedNotesModel } from '@/models/student-notes/note.model';
import { SharedNotebook } from '@/models/student-notes/shared-notebook.model';

const mutations: MutationTree<NoteState> = {
  SET_VIDEO_NOTES(state, notes: NoteModel[]) {
    (notes || []).forEach((note) =>
      Vue.set(state.videoNotes, note.id.toString(), {
        ...state.videoNotes[note.id],
        ...note,
      }),
    );
  },
  SET_NOTEBOOK_NOTES(state, groupedNotes: GroupedNotesModel[]) {
    state.groupedNotebookNotes = groupedNotes;
  },
  SET_LOADING_SHARED_NOTEBOOK(state, isLoadingSharedNotebook: boolean) {
    state.isLoadingSharedNotebook = isLoadingSharedNotebook;
  },
  SET_LOADING_NOTEBOOK_NOTES(state, isLoadingNotebookNotes: boolean) {
    state.isLoadingNotebookNotes = isLoadingNotebookNotes;
  },
  SET_LOADING_NOTES(state, isLoadingNotes: boolean) {
    state.isLoadingNotes = isLoadingNotes;
  },
  SET_GENERATING_SHARED_NOTEBOOK_LINK(state, isGeneratingSharedNotebookLink: boolean) {
    state.isGeneratingSharedNotebookLink = isGeneratingSharedNotebookLink;
  },
  SET_SHARED_NOTEBOOK(state, notebook: SharedNotebook | null) {
    state.sharedNotebook = notebook;
  },
  SET_OTHER_STUDENT_SHARED_NOTEBOOK(state, notebook: SharedNotebook | null) {
    state.otherStudentSharedNotebook = notebook;
  },
  SET_LOADING_NEW_NOTE_SAVE(state, isLoadingNewNoteSave: boolean) {
    state.isLoadingNewNoteSave = isLoadingNewNoteSave;
  },
  SET_CONFIRMATION_BOX(state, isConfirmationBoxOpened: boolean) {
    state.isConfirmationBoxOpened = isConfirmationBoxOpened;
  },
  SET_DELETING_ANNOTATION(state, isDeletingAnnotation: boolean) {
    state.isDeletingAnnotation = isDeletingAnnotation;
  },
  REMOVE_VIDEO_NOTE(state, id: number) {
    Vue.delete(state.videoNotes, id.toString());
  },
  REMOVE_CLASS_VIDEO_NOTE(state, id: Number) {
    Vue.delete(state.classVideoNotes, id.toString());
  },
  SET_CLASS_VIDEO_NOTES(state, notes: NoteModel[]) {
    (notes || []).forEach((note) =>
      Vue.set(state.classVideoNotes, note.id.toString(), {
        ...state.classVideoNotes[note.id],
        ...note,
      }),
    );
  },
};

export default mutations;
